import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import Completion from "../common/Completion";
import {
  getMypageCourseApplicantUser,
  postMypageCancelCourse,
} from "../../../../services/apiCourseApplicant";
import Loading from "../../../../components/ui/Loading";
import Progress from "../../../../components/ui/Progress";
import { APPLIED_COURSE } from "../../../../utils/config";

const CourseCancel = () => {
  // 講座ID
  const { id } = useParams();
  // 講座詳細データ
  const [detailData, setDetailData] = useState([]);
  // 完了画面かどうかのフラグ
  const [isCompFlg, setIsCompFlg] = useState(false);
  // ローディング表示
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const location = useLocation();
  const prev = location?.state?.prev;
  const backUrl =
    typeof prev !== "undefined" && prev === APPLIED_COURSE
      ? "/mypage/course/applied"
      : "../detail/" + detailData.id;

  const {
    handleSubmit,
    register,
    setValue,
    formState: { errors },
  } = useForm();

  // 講座をキャンセルするボタン
  const onSubmit = async (data) => {
    const json = await postMypageCancelCourse(id, data);
    if (json?.result) {
      setIsCompFlg(true);
      scrollTop();
    }
  };

  // スクロールを一番上に移動
  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  };

  useEffect(() => {
    // ローディング表示開始
    setLoading(true);
    // 講座情報、ユーザ情報取得
    (async function () {
      const data = await getMypageCourseApplicantUser({ id });
      if (data == undefined || !data) return;
      if (data.is_cancelable) {
        // データが取得できたらローディング表示終了
        setLoading(false);
        setDetailData(data);
        setValue("course_name", data.course_name);
        setValue("updated_at", data.updated_at);
      } else {
        // キャンセル不可の場合は404エラー
        navigate("/mypage/notfound");
      }
    })();
  }, []);

  return (
    <>
      {isCompFlg ? (
        <Completion
          title="講座キャンセル完了"
          explanation="お申し込みの講座をキャンセル致しました。"
          link="/mypage/course/applied"
          btntext="申込済みの講座ページに戻る"
        />
      ) : (
        <div className="l-page-right">
          <div className="l-page-con">
            <h1 className="p-heading01">講座キャンセル</h1>
            <div className="p-user-con01">
              <div className="p-user-link">
                <div className="p-user-link-item">
                  <a
                    className="p-user-link01"
                    href={
                      process.env.REACT_APP_SHIBUKATSU_WEB_DOMAIN +
                      "/mypage-manual/"
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    使い方を見る（新しいウィンドウで開きます）
                  </a>
                </div>
              </div>
              <h2 className="p-user-ttl">お申込内容</h2>
              <table className="p-user-tbl">
                <tbody>
                  <tr>
                    <th>講座名</th>
                    <td>{detailData.course_name}</td>
                  </tr>
                  <tr>
                    <th>学生番号</th>
                    <td>{detailData.login_id}</td>
                  </tr>
                  <tr>
                    <th>氏名</th>
                    <td>{detailData.name}</td>
                  </tr>
                  <tr>
                    <th>電話番号1</th>
                    <td>{detailData.phone1}</td>
                  </tr>
                  <tr>
                    <th>メールアドレス1</th>
                    <td>{detailData.mail1}</td>
                  </tr>
                  <tr>
                    <th>電話番号2</th>
                    <td>{detailData.phone2}</td>
                  </tr>
                  <tr>
                    <th>メールアドレス2</th>
                    <td>{detailData.mail2}</td>
                  </tr>
                </tbody>
              </table>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div hidden>
                  <input
                    type="text"
                    name="course_name"
                    {...register("course_name")}
                  />
                  <input
                    type="text"
                    name="updated_at"
                    {...register("updated_at")}
                  />
                </div>
                <div className="p-login-form__btnbox">
                  <div className="p-login-form__returnbtn">
                    <input
                      className="p-login-form__link"
                      type="button"
                      value="戻る"
                      onClick={() => navigate(backUrl)}
                    />
                  </div>
                  <div className="p-login-form__send">
                    <input
                      className="p-login-form__link"
                      type="submit"
                      value="講座をキャンセルする"
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
          {loading ? <Loading /> : <></>}
          {loading ? <Progress /> : <></>}
        </div>
      )}
    </>
  );
};

export default CourseCancel;
